/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import vopayApi from '../../services/api.config';
import useDataFetchIndicator from '../useDataFetchIndicator';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.AccountVerificationConfirmResponse,
  EmbedUrl: (params: vp.AccountVerificationConfirmRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostAccountVerificationConfirm: ApiHook = ({ api }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Common' });
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldAccountVerificationConfirm, setAccountVerificationConfirm] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.AccountVerificationConfirmRequest>({
    VerificationRequestID: '',
    Amount: '',
    Token: '',
  });
  const [response, setResponse] = useState<vp.AccountVerificationConfirmResponse>({
    Success: false,
    ErrorMessage: '',
    ConfirmationStatus: false,
  });

  useEffect(() => {
    if (!shouldAccountVerificationConfirm) return () => {};

    const PostAccountVerificationConfirm = async () => {
      setDataFetchingInfo(true, `${t('defaultLoading')}`, 'fullScreen');
      const res = await api.postAccountVerificationConfirm(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldAccountVerificationConfirm) void PostAccountVerificationConfirm();
    setAccountVerificationConfirm(false);
    return () => {
      source.cancel();
    };
  }, [shouldAccountVerificationConfirm]);

  return [
    response,
    (_params: vp.AccountVerificationConfirmRequest) => {
      setParams(_params);
      setAccountVerificationConfirm(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        ConfirmationStatus: false,
      });
      setAccountVerificationConfirm(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostAccountVerificationConfirm);
